import { forEach } from 'lodash';
import axios from 'redaxios';

const API_URL = process.env.GATSBY_PHP_API_URL;
const API_V2_URL = process.env.GATSBY_PHP_API_URL_2_0;

export const makeOfferUsedCar = (values: Object) => {
  const endpoint = `${API_URL}/end-point/endpoint-uc-send-offer.php`;

  const bodyFormData = new FormData();
  forEach(values, (v, k) => {
    bodyFormData.append(k, v || '');
  });

  return axios({
    method: 'POST',
    url: endpoint,
    data: new URLSearchParams(bodyFormData).toString(),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  }).catch(function (response) {
    console.log(response);
    message.error(
      'Some error happened when submit data. Please check your input data.'
    );
  });
};

export const signUpNewsletter = (values: Object) => {
  const endpoint = `${API_V2_URL}/end-point/newsletter-subs-add`;

  const bodyFormData = new FormData();
  forEach(values, (v, k) => {
    bodyFormData.append(k, v || '');
  });

  return axios({
    method: 'POST',
    url: endpoint,
    data: new URLSearchParams(bodyFormData).toString(),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  }).catch(function (response) {
    console.log(response);
    message.error(
      'Some error happened when submit data. Please check your input data.'
    );
  });
};
